module.exports = __webpack_public_path__ + "static/media/7-normal.2f29bcb6.png";